import React from "react";
import { handleApiErrors } from './api-errors'
import moment from 'moment-timezone';
const tz = 'Asia/Ho_Chi_Minh';
import AppConfig from '../config/app'
import { storedb } from '../views/client/storedb'

export const getParam = (location, name, defaultIfNull) => {
  const queryParamsString = location.search.substring(1) // remove the "?" at the start
  const searchParams = new URLSearchParams(queryParamsString)
  return searchParams.get(name) || defaultIfNull
}

export const HasPermission = (permission) => {
  const rolePermissions = storedb().getPermissionsRoles()
  if (!rolePermissions || rolePermissions.length == 0) {
    return false
  }
  if (permission && permission != '') {
    return rolePermissions.indexOf(permission) > -1 ? true : false;
  }
  return false
}
export const Uuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
export const isDate = (StringValue, stringFormat) => {
  if (!StringValue) {
    return false;
  }

  return moment(StringValue, stringFormat).isValid()
}
export const formatDateTimeString = (StringValue, stringFormat) => {
  if (!StringValue) {
    return moment().tz(tz).format(stringFormat);
  }

  return moment(StringValue).tz(tz).format(stringFormat);
}
export const formatDateTime = (inputValue, format = "YYYY-MM-DD HH:mm:ss") => {
  if (!inputValue) {
    return moment().tz(tz).format(format);
  }

  if (typeof inputValue === 'string') {
    inputValue = moment(new Date(inputValue))
  }

  return inputValue.tz(tz).format(format);
}

export const parseDatetime = (inputValue, defaultIfNull) => {
  if (!inputValue) {
    if (!defaultIfNull) {
      return null
    }
    return moment().tz(tz);
  }

  if (typeof inputValue === 'string') {
    inputValue = moment(new Date(inputValue))
  }

  return inputValue.tz(tz);
}
export const GetKhachHangStatusValue = () => {
  return [AppConfig.KHACHHANG_MOI, AppConfig.KHACHHANG_DANGHOATDONG, AppConfig.KHACHHANG_DAHUY]
}
export const GetCanhBaoTonKho = () => {
  return {
    CANH_BAO_SO_LUONG: AppConfig.CANH_BAO_SO_LUONG
  }
}
export const getKhachHangStatusText = (status) => {
  let result = ''
  let className = ''
  switch (status) {
    case AppConfig.KHACHHANG_MOI:
      result = "Chờ phê duyệt"
      className = 'bg-warning'
      break;
    case AppConfig.KHACHHANG_DANGHOATDONG:
      result = "Đang hoạt động"
      className = 'bg-success'
      break;
    case AppConfig.KHACHHANG_DAHUY:
      result = "Đã huỷ, tạm thời khoá"
      className = 'bg-danger'
      break;
    default:
      return ''
  }
  return {
    result: result,
    className: className
  }
}
export const getCustomerMarketingReceiveStatusText = (status, appendStyle = false) => {
  let result = ''
  let className = ''
  switch (status) {
    default:
    case AppConfig.CUSTOMER_MARKETING_RECEIVED_DSTATUS.DaNhan:
      result = AppConfig.CUSTOMER_MARKETING_RECEIVED_DSTATUS.DaNhanText
      className = 'text-warning'
      break;
    case AppConfig.CUSTOMER_MARKETING_RECEIVED_DSTATUS.DaDuyet:
      result = AppConfig.CUSTOMER_MARKETING_RECEIVED_DSTATUS.DaDuyet
      className = 'text-primary'
      break;
    case AppConfig.CUSTOMER_MARKETING_RECEIVED_DSTATUS.HoanThanh:
      result = AppConfig.CUSTOMER_MARKETING_RECEIVED_DSTATUS.HoanThanhText
      className = 'text-success'
      break;
  }

  if (appendStyle) {
    return (
      <b className={className}>{result}</b>
    )
  } else {
    return result
  }
}
export const getCustomerMarketingStatusText = (status, appendStyle = false) => {
  let result = ''
  let className = ''
  switch (status) {
    default:
    case AppConfig.CUSTOMER_MARKETING_STATUS.ChuaGui:
      result = AppConfig.CUSTOMER_MARKETING_STATUS.ChuaGuiText
      className = 'text-warning'
      break;
    case AppConfig.CUSTOMER_MARKETING_STATUS.DaGui:
      result = AppConfig.CUSTOMER_MARKETING_STATUS.DaGuiText
      className = 'text-secondary'
      break;
    case AppConfig.CUSTOMER_MARKETING_STATUS.DaNhan:
      result = AppConfig.CUSTOMER_MARKETING_STATUS.DaNhanText
      className = 'text-primary'
      break;
    case AppConfig.CUSTOMER_MARKETING_STATUS.HoanThanh:
      result = AppConfig.CUSTOMER_MARKETING_STATUS.HoanThanhText
      className = 'text-success'
      break;
  }

  if (appendStyle) {
    return (
      <b className={className}>{result}</b>
    )
  } else {
    return result
  }
}
export const getOrderMarketingStatusText = (status, appendStyle = false) => {
  let result = ''
  let className = ''
  switch (status) {
    default:
    case AppConfig.ORDER_MARKETING_STATUS.HoanThanhNhap:
      result = AppConfig.ORDER_MARKETING_STATUS.HoanThanhNhapText
      className = 'text-warning'
      break;
    case AppConfig.ORDER_MARKETING_STATUS.DangXuLy:
      result = AppConfig.ORDER_MARKETING_STATUS.DangXuLyText
      className = 'text-primary'
      break;
    case AppConfig.ORDER_MARKETING_STATUS.HoanThanh:
      result = AppConfig.ORDER_MARKETING_STATUS.HoanThanhText
      className = 'text-success'
      break;
    case AppConfig.ORDER_MARKETING_STATUS.Huy:
      result = AppConfig.ORDER_MARKETING_STATUS.HuyText
      className = 'text-danger'
      break;
  }

  if (appendStyle) {
    return (
      <b className={className}>{result}</b>
    )
  } else {
    return result
  }
}
export const getOrdetStatusText = (status, appendStyle = false) => {
  let result = ''
  let className = ''
  switch (status) {
    case AppConfig.ORDER_STATUS.Nhap:
      result = AppConfig.ORDER_STATUS.NhapText
      className = 'text-muted'
      break;
    case AppConfig.ORDER_STATUS.HoanThanhNhap:
      result = AppConfig.ORDER_STATUS.HoanThanhNhapText
      className = 'text-primary'
      break;
    case AppConfig.ORDER_STATUS.DangXuLy:
      result = AppConfig.ORDER_STATUS.DangXuLyText
      className = 'text-info'
      break;
    case AppConfig.ORDER_STATUS.HoanThanh:
      result = AppConfig.ORDER_STATUS.HoanThanhText
      className = 'text-success'
      break;
    case AppConfig.ORDER_STATUS.Huy:
      result = AppConfig.ORDER_STATUS.HuyText
      className = 'text-danger'
      break;
    default:
      return ''
  }

  if (appendStyle) {
    return (
      <b className={className}>{result}</b>
    )
  } else {
    return result
  }
}
// transfer object
export const transferFromCached = (dataCached) => {
  if (!dataCached) return {}
  if (!dataCached.table) return dataCached
  return dataCached.table
}

// transfer list objects
export const transfersFromCached = (datasCached) => {
  if (!datasCached) return []
  return datasCached.map((item) => {
    if (!item.table) return item
    return item.table
  })
}

export const currentDate = () => {
  return moment().tz(tz);
}

export const getDayFromDate = (date) => {
  return moment(date).tz(tz).format('M');
}

export const getMonthFromDate = (date) => {
  return moment(date).tz(tz).format('M');
}

export const getYearFromDate = (date) => {
  return moment(date).tz(tz).format('YYYY');
}

export const storeInfo = () => {
  let result = {};
  try {
    const storedToken = localStorage.getItem('token')
    if (storedToken && storedToken != 'undefined') {
      result = JSON.parse(storedToken)
    }
  } catch (error) {
    console.log(error);
  }

  return result;
}


export async function handleRequest(request) {
  const result = await request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => {
      const errStr = error.toString()
      if (errStr.indexOf('Request failed with status code 500') > -1) {
        throw 'Lỗi kết nối, xin hãy thử lại';
      }
      throw error;
    });

  return result;
}

export function sum(items, key) {
  return items.reduce((a, b) => a + (b[key] || 0), 0)
}
// selected Option Array obj  or obj
export function mapArray(ArrayObj) {
  var arrayValue = [];
  if (ArrayObj == null) {
    return arrayValue;
  }
  if (Array.isArray(ArrayObj)) {
    ArrayObj.forEach(function (item) {
      if (item.value != 0) {
        arrayValue.push(item.value);
      }
    });
  } else {
    arrayValue.push(ArrayObj.value);
  }
  return arrayValue;
}
export function abs2number(a, b) {
  return (a - b) > 0 ? (a - b) : 0
}
export const barCodeFirst = (input, digitLenght = 13) => {
  let str = `${input}`
  if (str.length >= digitLenght) return str;
  const leftInsert = digitLenght - str.length
  for (let i = 0; i < leftInsert; i++) {
    str = `0${str}`
  }
  return str
}
export const customSelectStyles = {
  control: base => ({
    ...base,
    height: 30,
    minHeight: 30,
    borderRadius: 0,
    border: "none"
  })
};
export const customSelectStylesMulti = {
  control: base => ({
    ...base,
    minHeight: 30,
    borderRadius: 0,
    border: "none"
  })
};
export const inputFileType = {
  INPUT: 1,
  CHECKBOX: 2,
  TEXTAREA: 3,
  IMAGE: 4,
};

export const queryEncoding = function (obj) {
  try {
    if (obj == null) return ""
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  } catch (error) {
    return obj
  }
}

export const removeUnicode = (inputStr, skipSpace) => {
  if (!inputStr) {
    return ""
  }
  let str = inputStr.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").trim()
  if (!skipSpace) {
    str = str.replace(/\s/g, '')
  }
  return str;
}

export const number2Text = (input) => {
  if (!input) {
    return ""
  }
  var DOCSO = function () { var t = ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"], r = function (r, n) { var o = "", a = Math.floor(r / 10), e = r % 10; return a > 1 ? (o = " " + t[a] + " mươi", 1 == e && (o += " mốt")) : 1 == a ? (o = " mười", 1 == e && (o += " một")) : n && e > 0 && (o = " lẻ"), 5 == e && a >= 1 ? o += " lăm" : 4 == e && a >= 1 ? o += " tư" : (e > 1 || 1 == e && 0 == a) && (o += " " + t[e]), o }, n = function (n, o) { var a = "", e = Math.floor(n / 100), n = n % 100; return o || e > 0 ? (a = " " + t[e] + " trăm", a += r(n, !0)) : a = r(n, !1), a }, o = function (t, r) { var o = "", a = Math.floor(t / 1e6), t = t % 1e6; a > 0 && (o = n(a, r) + " triệu", r = !0); var e = Math.floor(t / 1e3), t = t % 1e3; return e > 0 && (o += n(e, r) + " nghìn", r = !0), t > 0 && (o += n(t, r)), o }; return { doc: function (r) { if (0 == r) return t[0]; var n = "", a = "", ty = undefined; do ty = r % 1e9, r = Math.floor(r / 1e9), n = r > 0 ? o(ty, !0) + a + n : o(ty, !1) + a + n, a = " tỷ"; while (r > 0); return n.trim() } } }();
  let str = input.toString().trim()
  str = DOCSO.doc(str)
  return str.charAt(0).toUpperCase() + str.slice(1)
}
export const DataURLtoFile = (dataurl, filename) => {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}
export const GetCurrentDayName = () => {
  var date = new Date();
  var current_day = date.getDay();
  var day_name = '';
  switch (current_day) {
    case 0:
      day_name = "Chủ nhật";
      break;
    case 1:
      day_name = "Thứ hai";
      break;
    case 2:
      day_name = "Thứ ba";
      break;
    case 3:
      day_name = "Thứ tư";
      break;
    case 4:
      day_name = "Thứ năm";
      break;
    case 5:
      day_name = "Thứ sáu";
      break;
    case 6:
      day_name = "Thứ bảy";
  }
  return day_name;
}


// WEBPACK FOOTER //
// ./src/lib/common.js